import axios from "axios";

const getApiUrl = () => process.env.REACT_APP_PUBLIC_API_URL;

export const api = axios.create({
  baseURL: getApiUrl(),
});

// 자주 묻는 질문 조회
export const getAskedQuestions = () =>
  api.get(`/support/faq?page=1&limit=999999999`);

// 약관 조회
export const getTerms = () => api.get(`/service-static/terms`);

// 파비콘 조회
export const getFavicon = () => api.get(`/service-static/favicon`);

// 랜딩 페이지 정보
export const getLandingPageInfo = () =>
  api.get(`/service-static/landing-page-info`);

// 회사 정보
export const getCompanyInfo = () => api.get(`/service-static/company`);

// 회원 탈퇴
export const deleteUser = (removeReason) =>
  api.delete("/auth/me", {
    removeReason,
  });
